export default __webpack_public_path__ + "static/media/audio/cannon-shot-hit-sink-ship.7e99e2ea87d44bc3066699c25d05359c.mp3";